import React from 'react';
import { Link as Anchor } from "react-router-dom";

export default class Link extends React.Component {
    render() {
        const { children = "", to = "", className = false, onClick = () => { }, target = "_self", disabled = false, download = false, style = {} } = this.props;
        let mailtoCondt = (to.indexOf("mailto:") !== -1);
        let telCondt = (to.indexOf("tel:") !== -1);
        let httpCondt = (to.indexOf("http") !== -1);

        if (disabled) {
            return (
                <div className={`${className}`} style={style}>
                    {children}
                </div>
            )
        }

        if (download === true) {
            return (
                <a className={`${className}`} href={to} onClick={onClick} download style={style}>
                    {children}
                </a>
            )
        }

        if (httpCondt) {
            return (
                <a className={`${className}`} href={to} target="_blank" rel="noreferrer" onClick={onClick} style={style}>
                    {children}
                </a>
            );
        }

        if (mailtoCondt || telCondt) {
            return (
                <a className={`${className}`} href={to} onClick={onClick} style={style}>
                    {children}
                </a>
            );
        }

        if (to) {
            return (
                <Anchor className={`${className}`} to={to} target={target} onClick={onClick} style={style}>
                    {children}
                </Anchor>
            )
        }

        return (
            <button type="button" className={`${className}`} onClick={onClick} style={style}>
                {children}
            </button>
        );
    }
}